export default {
  Terbilang: function terbilang(bilangan) {
    bilangan = String(bilangan);
    let angka = new Array(
      "0",
      "0",
      "0",
      "0",
      "0",
      "0",
      "0",
      "0",
      "0",
      "0",
      "0",
      "0",
      "0",
      "0",
      "0",
      "0",
    );
    let kata = new Array(
      "",
      "Satu",
      "Dua",
      "Tiga",
      "Empat",
      "Lima",
      "Enam",
      "Tujuh",
      "Delapan",
      "Sembilan",
    );
    let tingkat = new Array("", "Ribu", "Juta", "Milyar", "Triliun");

    let panjang_bilangan = bilangan.length;

    /* pengujian panjang bilangan */
    if (panjang_bilangan > 15) {
      let kaLimat = "Diluar Batas";
      return kaLimat;
    }

    /* mengambil angka-angka yang ada dalam bilangan, dimasukkan ke dalam array */
    for (let i = 1; i <= panjang_bilangan; i++) {
      angka[i] = bilangan.substr(-i, 1);
    }

    let i = 1;
    let j = 0;
    let kaLimat = "";

    /* mulai proses iterasi terhadap array angka */
    while (i <= panjang_bilangan) {
      let subkaLimat = "";
      let kata1 = "";
      let kata2 = "";
      let kata3 = "";

      /* untuk Ratusan */
      if (angka[i + 2] != "0") {
        if (angka[i + 2] == "1") {
          kata1 = "Seratus";
        } else {
          kata1 = kata[angka[i + 2]] + " Ratus";
        }
      }

      /* untuk Puluhan atau Belasan */
      if (angka[i + 1] != "0") {
        if (angka[i + 1] == "1") {
          if (angka[i] == "0") {
            kata2 = "Sepuluh";
          } else if (angka[i] == "1") {
            kata2 = "Sebelas";
          } else {
            kata2 = kata[angka[i]] + " Belas";
          }
        } else {
          kata2 = kata[angka[i + 1]] + " Puluh";
        }
      }

      /* untuk Satuan */
      if (angka[i] != "0") {
        if (angka[i + 1] != "1") {
          kata3 = kata[angka[i]];
        }
      }

      /* pengujian angka apakah tidak nol semua, lalu ditambahkan tingkat */
      if (angka[i] != "0" || angka[i + 1] != "0" || angka[i + 2] != "0") {
        subkaLimat = kata1 + " " + kata2 + " " + kata3 + " " + tingkat[j] + " ";
      }

      /* gabungkan variabe sub kaLimat (untuk Satu blok 3 angka) ke variabel kaLimat */
      kaLimat = subkaLimat + kaLimat;
      i = i + 3;
      j = j + 1;
    }

    /* mengganti Satu Ribu jadi Seribu jika diperlukan */
    if (angka[5] == "0" && angka[6] == "0") {
      kaLimat = kaLimat.replace("Satu Ribu", "Seribu");
    }

    return kaLimat + "Rupiah";
  },

  FDate: function (value) {
    let tgl = value;
    let d = tgl.split("-");
    let x = new Date(d[2] + "/" + d[1] + "/" + d[0]);

    const date = new Date(x);
    const dateTimeFormat = new Intl.DateTimeFormat("id", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
    });

    const formatted = dateTimeFormat.formatToParts(date);

    return (
      formatted[4].value + "-" + formatted[2].value + "-" + formatted[0].value
    );
  },

  rupiah: (angka) => {
    if (angka) {
      var number_string = angka.toString(),
        sisa = number_string.length % 3,
        rupiah = number_string.substr(0, sisa),
        ribuan = number_string.substr(sisa).match(/\d{3}/g);

      if (ribuan) {
        let separator = sisa ? "." : "";
        rupiah += separator + ribuan.join(".");
      }

      return rupiah;
    } else {
      return 0;
    }
  },

  tanggal: (tgl) => {
    const date = new Date(tgl);
    const dateTimeFormat = new Intl.DateTimeFormat("id", {
      year: "numeric",
      month: "long",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
    });
    const formatted = dateTimeFormat.formatToParts(date);

    return (
      formatted[0].value + " " + formatted[2].value + " " + formatted[4].value
    );
  },

  bulan: (tgl) => {
    const date = new Date(tgl);
    const dateTimeFormat = new Intl.DateTimeFormat("id", {
      year: "numeric",
      month: "long",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
    });
    const formatted = dateTimeFormat.formatToParts(date);

    return formatted[2].value;
  },

  waktu: (tgl) => {
    const date = new Date(tgl);
    const dateTimeFormat = new Intl.DateTimeFormat("id", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
    });
    const formatted = dateTimeFormat.formatToParts(date);

    return (
      formatted[0].value +
      "/" +
      formatted[2].value +
      "/" +
      formatted[4].value +
      " | " +
      formatted[6].value +
      ":" +
      formatted[8].value
    );
  },

  vuetgl: (inputDate) => {
    // Pastikan inputDate adalah objek Date
    const date = new Date(inputDate);

    // Tambahkan 23 jam, 3 menit, dan 39 detik
    const offsetInSeconds = 23 * 3600 + 3 * 60 + 39;
    date.setSeconds(date.getSeconds() + offsetInSeconds);

    // Format output ke YYYY-MM-DD HH:mm:ss (dalam waktu lokal)
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    // const hours = String(date.getHours()).padStart(2, "0");
    // const minutes = String(date.getMinutes()).padStart(2, "0");
    // const seconds = String(date.getSeconds()).padStart(2, "0");

    // return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return `${year}-${month}-${day}`;
  },
};
